






































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../lib/util'
import AbpBase from '../../lib/abpbase'
import CompanyInformation from '../../store/entities/companyinformation'
@Component
export default class EditCompanyInformation extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    companyinformation:CompanyInformation=new CompanyInformation();
    created(){
        
    }
   
    save(){
        (this.$refs.companyinformationForm as any).validate(async (valid:boolean)=>{
            if(valid){
                await this.$store.dispatch({
                    type:'companyinformation/update',
                    data:this.companyinformation
                });
                (this.$refs.companyinformationForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
            }
        })
    }
    cancel(){
        (this.$refs.companyinformationForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
       
        if(!value){
            this.$emit('input',value);
        }else{
            this.companyinformation=Util.extend(true,{},this.$store.state.companyinformation.editCompanyinformation);
        }
    }
    companyinformationRule={
        userName:[{required: true,message:this.L('FieldIsRequired',undefined,this.L('UserName')),trigger: 'blur'}],
        name:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('Name')),trigger: 'blur'}],
        surname:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('Surname')),trigger: 'blur'}],
        emailAddress:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('Email')),trigger: 'blur'},{type: 'email'}],
    }
}
